/**
 * Created by rickborst on 25/04/2017.
 */

import _ from 'lodash';

import {ImageRatios} from 'models/image';

const getRatio = function (ratio) {

    switch (ratio) {

        case '16:9':
        case '5LIVE':
        case 'Poster': // TODO: Remove this when Kaluta provides correct ratio's again
            return ImageRatios['16:9'];

        case '2:3':
            return ImageRatios['2:3'];

        case '3:2':
            return ImageRatios['3:2'];

        case '1:1':
        case 'TeamLogo':
        case 'vsTeamLogo':
        case 'LeagueLogo':
            return ImageRatios['1:1'];

        default:
            return null;
    }
};

/**
 * Converts image data from read data.
 *
 * @param {Object} [data] - Image data.
 * @returns {Object} Converted image data.
 */
export function convertImageFromRead (data = {}) {

    return {
        id: data.id || '',
        height: data.height || null,
        width: data.width || null,
        ratio: getRatio.call(this, data.ratio),
        url: data.url || '',
        apiSpecifics: {
            version: data.version || 0,
            objectType: data.objectType || '',
            isDefault: data.isDefault || false
        }
    };
}

/**
 * Converts images data from read data.
 *
 * @param {Array} [data] - Read data.
 * @returns {Array} Images data.
 */
export function convertImagesFromRead (data = []) {

    if (!_.isArray(data)) {
        data = [data];
    }

    return _.map(data, convertImageFromRead.bind(this));
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/images.js